<template>
  <div>
    <div>
        <label>抓取时段可抓取天数</label>
        <el-input v-model.number="input" :disabled="isView" class="ml20" style="width: 220px" placeholder="请输入"/>
    </div>
    <p class="text-color-gray mt10">-1表示不限，限制值可输入1-1000</p>
    <div class="btns">
        <el-button @click="$emit('close')">取消</el-button>
        <el-button type="primary" :disabled="isView" @click="handleClick">确定</el-button>
    </div>
  </div>
</template>

<script>
import { validNum  } from '@/utils/validate'
export default {
    name:'RetryDataModal',
    props: [ 'isView', 'retry_period', 'cbs' ],
    data() {
        return {
            input: this.retry_period || ''
        }
    },
    methods: {
        handleClick() {
            const input  = this.input+''
            if (input === '-1') {
                this.cbs.onSubmit(input);
                return;
            };
            if (validNum(input) && 1<=+input && +input<=1000) {
                this.cbs.onSubmit(input);
                return;
            }else {
                this.$message.error('请输入1到1000的数字')
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.btns {
    margin-top: 20px;
    text-align: center;
}

</style>